import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './MostActiveContracts.css';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import { format, parseISO } from 'date-fns';
import FandOFut from "../FandOFut";
import { Vortex } from 'react-loader-spinner'
function MostActiveContracts() {
    const [data, setData] = useState([]);

    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingshow, setloadingshow] = useState(false);
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        window.scrollTo(0, 0)
        const getUrl = BaseURL + "HighLowOpenIntrest";


        fetch(`${getUrl}/mw/-/fut/-/-/-/-/-/-`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                setloadingshow(false);
                console.log(getData, "getData")
            })
            .catch((error) => {
            });


    }, []);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);


    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/futures-and-options">F & O</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Most Active Contracts</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='ActiMost-loser-sc'>
                            <div className='ActiMost-header'>
                                <h2><span>Most Active Contracts</span></h2>
                            </div>
                            <FandOFut optionValue="Most Active Contracts" optionDrop="Futures" />
                            {/* <hr className="Mosthr"></hr> */}
                            <div className='ActiMost-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>

                                            <th className='text-left' >Instrument Type</th>
                                            <th className='text-left' >Symbol</th>
                                            <th className='text-right'>Expiry Date</th>
                                            {/* <th className='text-right'>Last Price(&#8377;)</th> */}
                                            <th className='text-right'>No Of Contracts</th>
                                            <th className='text-right'>Traded Value(&#8377;)</th>

                                        </tr>

                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(

                                            ({ InstName, Symbol, ExpDate, TradedQty, Turnover, LTP }) => (
                                                <tr>
                                                    <td className="text-left"> {InstName}</td>
                                                    <td className="text-left"> {Symbol}</td>
                                                    <td className="text-right">{format(parseISO(ExpDate), 'dd-MMM-yyyy')}</td>
                                                    {/* <td className="text-right"> {(LTP != null) ? LTP.toFixed(2) : 0}</td> */}
                                                    {/* <td className="text-right"> {(ExpDate != null) ? ExpDate.split('T')[0] : 0}</td> */}
                                                    {/* <td className="text-right"> {(TradedQty != null) ? TradedQty.toFixed(2) : 0}</td> */}
                                                    <td className='text-right'>{TradedQty.toFixed(2)}</td>
                                                    <td className="text-right"> {Turnover.toFixed(2)}</td>

                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default MostActiveContracts;